import { atom } from 'recoil';
import { type InformationModalVariant } from '../types/opcTypes';

export const infoModalVariantOpcAtom = atom<InformationModalVariant>({
    key: 'infoModalVariantOpcAtom',
    default: undefined
});
